export { default as WebModal } from './AcModal';
export { default as MobileModal } from './MobileModal';

export type { ModalProps } from './type';
